import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import { getPriceSchemeApi } from "../../../api/pricescheme";
import PriceSchemeList from "./priceSchemeList";
import { AddEditPrice } from "./AddEditPriceScheme";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Payment = () => {
  const [openPrice, setOpenPrice] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedtPriceScheme, setPaginatedtPriceScheme] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    gettPriceScheme({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedtPriceScheme(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    gettPriceScheme({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedtPriceScheme(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    gettPriceScheme({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedtPriceScheme(res.data?.data);
    });
  };

  const gettPriceScheme = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await PriceSchemeMutation(params);
  };

  const { mutateAsync: PriceSchemeMutation, isLoading: istPriceSchemeLoading } =
    useMutation("priceSchemes", getPriceSchemeApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>

          <AddButton onClick={() => setOpenPrice(true)} />
        </Col>
        <Col span={24}>
          <PriceSchemeList
            setPage={setPage}
            page={page}
            filter={filter}
            search={search}
            istPriceSchemeLoading={istPriceSchemeLoading}
            paginatedtPriceScheme={paginatedtPriceScheme}
            setPaginatedtPriceScheme={setPaginatedtPriceScheme}
            PriceSchemeMutation={PriceSchemeMutation}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      {openPrice && (
        <AddEditPrice
          openPrice={openPrice}
          setOpenPrice={setOpenPrice}
          page={page}
          filter={filter}
          search={search}
          setPaginatedtPriceScheme={setPaginatedtPriceScheme}
          PriceSchemeMutation={PriceSchemeMutation}
        />
      )}
    </>
  );
};

export default Payment;
